import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { change, getFormValues } from 'redux-form';
import JobCompletion from './JobCompletion';
import {
  getContactsByAreaId,
  getDefaultContactsByNoticeKey,
  getDefaultSendNoticeOfCompletion
} from 'selectors/formSelectors';
import { jobCompletionForm } from 'constants/FormConstants';
import { useNavigate } from 'react-router-dom';
import { NavItem } from 'reactstrap';

const JobCompletionContainer = (props) => {
  const dispatch = useDispatch();
  
  // Get current job from state
  const currentJob = useSelector((state) => state.currentJob);
  const areaId = currentJob.areaId;
  //const state1 = useSelector((state)=> state)
  //const referenceData1 =state1.referenceData;
 // const navigate = useNavigate;
  // Use useSelector to access the necessary state for initialValues
  const referenceData = useSelector((state) => state.referenceData);

  const initialValues = {
    newNoticeOfCompletion: {
      sendNotice: getDefaultSendNoticeOfCompletion(currentJob.currentState),
      contactIds: getDefaultContactsByNoticeKey(
        referenceData,
        currentJob.areaId,
        'defaultForNotificationOfCompletion'
      ),
    },
  };

  // Get contacts and form values
  const contacts = useSelector((state) => getContactsByAreaId(state, areaId));
  const formValues = useSelector((state) => getFormValues(jobCompletionForm)(state));
  return (
    <JobCompletion
      currentJob={currentJob}
      currentState={currentJob.currentState}
      referenceData={referenceData}
      initialValues={initialValues}
      contacts={contacts}
      formValues={formValues}
      changeFieldValue={(field, value) => dispatch(change(jobCompletionForm, field, value))}
    />
  );
};

export default JobCompletionContainer;
